module.exports = __webpack_public_path__ + "static/media/external-link~ZkfuIklB.f6dd039c.svg";